import wixLocation from 'wix-location';
import wixData from 'wix-data';
import { getEventsForTeamSlug } from 'backend/scheduleCache';

const SPORT = 'Football';
const STAYKER_BASE = 'https://booking.stayker.com';

$w.onReady(async () => {
    console.log('🏈 Football team page ready');
    $w('#gamesRepeater').hide();
    $w('#loadingText').text = 'Loading schedule...';
    $w('#loadingText').expand();
    $w('#loadingText').show();

    const segments = wixLocation.path || [];
    const teamSlug = (segments[0] || '').trim();
    console.log('URL segments:', segments, '→ teamSlug:', teamSlug);

    if (!teamSlug) {
        console.warn('No slug found in URL');
        $w('#loadingText').text = 'No team in URL.';
        $w('#loadingText').expand();
        $w('#loadingText').show();
        emptyRepeater('No team in URL.');
        return;
    }

    try {
        const { events, refreshed, reason } = await getEventsForTeamSlug(teamSlug, SPORT);
        console.log(`Events: ${events.length}, refreshed: ${refreshed}, reason: ${reason}`);
        if (reason.includes('No team found')) {
            $w('#loadingText').text = `No team found for ${teamSlug}.`;
            $w('#loadingText').expand();
            $w('#loadingText').show();
            emptyRepeater(`No team found for slug: ${teamSlug}`);
            return;
        }
        const items = (events || []).map(ev => mapEventForUI(ev, teamSlug));
        bindRepeater(items);
        $w('#loadingText').hide();
    } catch (e) {
        console.error('Failed to load schedule:', e);
        $w('#loadingText').text = 'Could not load schedule. Please try again.';
        $w('#loadingText').expand();
        $w('#loadingText').show();
        emptyRepeater('Could not load schedule.');
    }
});

function mapEventForUI(ev, teamSlug) {
    const name = ev?.name || '';
    const iso = ev?.date || null;
    const dateObj = iso ? new Date(iso) : null;
    const dateStr = dateObj ? formatDateLong(dateObj) : '';
    const timeStr = dateObj ? formatTimeShort(dateObj) : '';
    const venueCity = ev?.venueCity || '';
    const venueState = ev?.venueState || '';
    const locStr = [venueCity, venueState].filter(Boolean).join(', ');
    const ticketsUrl = ev?.ticketUrl || '';
    const staykerUrl = dateObj ? buildStaykerUrl(teamSlug, dateObj) : ''; // Default to home team

    return {
        _id: ev?.ticketmasterId || Math.random().toString(36).substring(7),
        title: name,
        dateStr,
        timeStr,
        locationStr: locStr,
        ticketsUrl,
        staykerUrl
    };
}

function buildStaykerUrl(teamSlug, gameDate) {
    const checkIn = shiftDays(gameDate, -1);
    const checkOut = shiftDays(gameDate, 1);
    const qs = new URLSearchParams({
        checkin: toYMD(checkIn),
        checkout: toYMD(checkOut),
        currency: 'USD',
        sort: 'featured',
    });
    return `${STAYKER_BASE}/${teamSlug}-event?${qs.toString()}`;
}

function shiftDays(dateObj, days) {
    const d = new Date(dateObj.getTime());
    d.setDate(d.getDate() + days);
    return d;
}

function toYMD(dateObj) {
    const y = dateObj.getUTCFullYear();
    const m = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
    const d = String(dateObj.getUTCDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

function formatDateLong(dateObj) {
    try {
        return dateObj.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' });
    } catch {
        return toYMD(dateObj);
    }
}

function formatTimeShort(dateObj) {
    try {
        return dateObj.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    } catch {
        return '';
    }
}

function bindRepeater(items) {
    const has = Array.isArray(items) && items.length > 0;
    $w('#gamesRepeater').onItemReady(($item, data) => {
        $item('#gameTitleText').text = data.title || '';
        $item('#gameDateText').text = data.dateStr || '';
        $item('#gameTimeText').text = data.timeStr || '';
        $item('#gameLocationText').text = data.locationStr || '';

        if (data.ticketsUrl) {
            $item('#bookTicketsButton').label = 'Tickets';
            $item('#bookTicketsButton').link = data.ticketsUrl;
            $item('#bookTicketsButton').target = '_blank';
            $item('#bookTicketsButton').show();
        } else {
            $item('#bookTicketsButton').hide();
        }

        if (data.staykerUrl) {
            $item('#bookHotelButton').label = 'Hotels';
            $item('#bookHotelButton').link = data.staykerUrl;
            $item('#bookHotelButton').target = '_blank';
            $item('#bookHotelButton').show();
        } else {
            $item('#bookHotelButton').hide();
        }

        $item('#localGuide').label = 'Local Guide (coming soon)';
        $item('#localGuide').hide();
    });

    $w('#gamesRepeater').data = has ? items : [];
    if (has) {
        $w('#gamesRepeater').expand();
        $w('#gamesRepeater').show();
    } else {
        $w('#gamesRepeater').hide();
        $w('#gamesRepeater').collapse();
    }
}

function emptyRepeater(msg) {
    if (msg) console.warn(msg);
    bindRepeater([]);
}